import { useEffect, useState } from 'react';
import './Toast.css';

const Toast = ({ 
  type, 
  title, 
  message, 
  onClose, 
  autoClose = true, 
  autoCloseDuration = 2500,
  position = 'top-center' // Default position
}) => {
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    if (!autoClose) return;

    const timer = setTimeout(() => {
      handleClose();
    }, autoCloseDuration);

    return () => {
      clearTimeout(timer);
    };
  }, [autoClose, autoCloseDuration]);

  const handleClose = () => {
    setIsExiting(true);
    setTimeout(() => {
      onClose();
    }, 200);
  };

  // Get icon based on type
  const getIconSvg = () => {
    if (type === 'success') {
      return (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
      );
    } else if (type === 'error') {
      return (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      );
    } else if (type === 'warning') {
      return (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
          <path d="M12 9v4M12 17h.01" strokeLinecap="round" />
          <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z" />
        </svg>
      );
    } else {
      return (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="16" x2="12" y2="12" />
          <circle cx="12" cy="8" r="1" fill="currentColor" />
        </svg>
      );
    }
  };

  return (
    <div 
      className={`hvnly-toast ${type} ${isExiting ? 'hvnly-toast-exit' : ''}`}
      data-position={position}
    >
      <div className="hvnly-toast-icon">
        {getIconSvg()}
      </div>
      
      <div className="hvnly-toast-content">
        <div className="hvnly-toast-title">{title}</div>
        {message && <div className="hvnly-toast-description">{message}</div>}
      </div>
      
      <button 
        className="hvnly-toast-close" 
        onClick={handleClose}
        aria-label="close"
      >
        ✕
      </button>
    </div>
  );
};

export default Toast;